// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2947":"11b01132","3073":"f1a256cd","5894":"79306b73","8082":"79306b73","8160":"67cf5048"}[chunkId] + ".chunk.css";
};